export default "__VITE_ASSET__Cqg1CQaE__"